// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "mobile-nav-module--base-text-alt--global--ee3ff";
export var baseTextGlobal = "mobile-nav-module--base-text--global--55878";
export var blockSpacing100 = "mobile-nav-module--block-spacing-100--76181";
export var blockSpacing50 = "mobile-nav-module--block-spacing-50--e03fd";
export var blockVPadding100 = "mobile-nav-module--block-v-padding-100--66c34";
export var blockVPadding50 = "mobile-nav-module--block-v-padding-50--00311";
export var brandLogoContainer = "mobile-nav-module--brandLogoContainer--25574";
export var captionTextGlobal = "mobile-nav-module--caption-text--global--5136d";
export var closeIcon = "mobile-nav-module--closeIcon--fad12";
export var closeIconHidden = "mobile-nav-module--closeIconHidden--abf5d";
export var closeIconVisible = "mobile-nav-module--closeIconVisible--dc2bb";
export var cmsRenderedContentGlobal = "mobile-nav-module--cms-rendered-content--global--0a9fd";
export var container = "mobile-nav-module--container--baebb";
export var contractAnimation = "mobile-nav-module--contractAnimation--cd802";
export var defaultHSpacingGlobal = "mobile-nav-module--default-h-spacing--global--ca0ea";
export var expandAnimation = "mobile-nav-module--expandAnimation--754ac";
export var expanded = "mobile-nav-module--expanded--c0471";
export var fadeInAnimation = "mobile-nav-module--fadeInAnimation--9aa17";
export var fadeInOnLoadGlobal = "mobile-nav-module--fade-in-on-load--global--3b026";
export var fullHeightGlobal = "mobile-nav-module--full-height--global--e3b34";
export var fullHeightOmittingNavGlobal = "mobile-nav-module--full-height-omitting-nav--global--8101a";
export var headingTextGlobal = "mobile-nav-module--heading-text--global--fa16d";
export var hidden = "mobile-nav-module--hidden--da27f";
export var hideClosedIcon = "mobile-nav-module--hideClosedIcon--05d3b";
export var iconAnimated = "mobile-nav-module--iconAnimated--00aab";
export var iconContainer = "mobile-nav-module--iconContainer--8f91a";
export var ingressTextGlobal = "mobile-nav-module--ingress-text--global--94f8d";
export var linkColorChangeTransitionGlobal = "mobile-nav-module--link-color-change-transition--global--606e0";
export var linkText = "mobile-nav-module--linkText--f4474";
export var mobileMenuToggle = "mobile-nav-module--mobileMenuToggle--e57bd";
export var mobileNavBarHeight = "85px";
export var navFooter = "mobile-nav-module--navFooter--da0aa";
export var navLink = "mobile-nav-module--navLink--2981d";
export var navLinkContainer = "mobile-nav-module--navLinkContainer--45a0c";
export var navMenu = "mobile-nav-module--navMenu--aed7d";
export var navMenuAnimated = "mobile-nav-module--navMenuAnimated--e8d82";
export var openIcon = "mobile-nav-module--openIcon--c760f";
export var openIconHidden = "mobile-nav-module--openIconHidden--0b929";
export var pageHeadingTextGlobal = "mobile-nav-module--page-heading-text--global--54873";
export var paragraphTextGlobal = "mobile-nav-module--paragraph-text--global--a64ad";
export var showClosedIcon = "mobile-nav-module--showClosedIcon--f1197";
export var subheadingTextGlobal = "mobile-nav-module--subheading-text--global--d089c";